export interface ICreateIncentive {
    name: string;
    description?: string | null;
    cost: number;
    status?: number; // 1=active, 2=inactive
    driverClassificationId: number;
}

export interface IUpdateIncentive extends ICreateIncentive {
}

export interface IExportIncentiveExcel {
    id: boolean;
    name: boolean;
    description: boolean;
    cost: boolean;
    status: boolean;
    driverClassificationId: boolean;
    createdAt: boolean;
}

export const columnsExportIncentiveExcel = [
    "id",
    "name",
    "description",
    "cost",
    "status",
    "driverClassification",
    "createdAt",
];